import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * SPA route tracker for Google Analytics 4.
 * GA only auto-fires the initial pageview — subsequent client-side
 * navigations must be sent manually.
 */
export default function GAPageTracker() {
  const location = useLocation();

  useEffect(() => {
    if (typeof window.gtag !== "function") return;
    const path = location.pathname + location.search;
    window.gtag("event", "page_view", {
      page_path: path,
      page_location: window.location.href,
      page_title: document.title,
    });
  }, [location.pathname, location.search]);

  return null;
}
